import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";
import Router from "./Router";
import "./index.css";
import "./tailwind.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RecoilRoot>
    <Router />
  </RecoilRoot>
);
